export class VanishingPoint {
  constructor(canvas) {
    this.canvas = canvas;
    this.update();
  }
  update() {
    this.x = this.canvas.width / 2;
    this.y = this.canvas.height / 2;
  }
  draw() {
    // Optionally draw on canvas, but you also have the #vanishingPoint div for reference
    // The dot is handled by the HTML/CSS
  }
  get position() {
    return { x: this.x, y: this.y };
  }
}